<template>
  <div style="height:100%">
    <SplitContainer21 style="height:100%" :layout="12">
      <template #top>
        <TableMain name="one table" ref="CustTable1" :fields="fields" :title="table_title.title1"
          :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="true" :show_toolbar="false" :show_toolbar_state="false" :show_filter="true"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :isBusy="isBusy_table1"
          :hb_table_class="'hb_table_custsei_class1'" :table_height_adjust="-8" :show_toolbar_button="[0, 0, 0, 0, 0]"
          :loading_width="60" @on_query="on_query" @current_changed="current_changed"
          @on_cell_button_click="on_cell_button_click">
          <template #query>
            {{ $t("common.customer") + $t("common.account") }}：<el-input clearable size="small" style="width: 150px"
              v-model="AccountNum"></el-input>
            {{ $t("common.customer") + $t("common.name") }}：<el-input clearable size="small" style="width: 200px"
              v-model="SEI_Name"></el-input>
          </template>
          <template #toolbar>
            <el-tooltip content="数据同步" placement="top" effect="light">
              <el-button type="info" plain style="width: 55px" class="ml-2" @click="InvokeData"><i
                  class="iconfont icon-refresh"></i></el-button>
            </el-tooltip>
          </template>
          <template #operation>
            <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveData"
              :label="$t('common.save')" class="ml-2">
            </QueryButton>
          </template>
        </TableMain>
      </template>
      <template #bottom>
        <TableMain name="one table" ref="CustTable2" :fields="fields2" :title="table_title.title2"
          :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
          :show_date_picker="false" :show_toolbar="false" :show_toolbar_state="false" :show_filter="true"
          :date_picker_label="date_picker_label" :query_button_label="query_lable" :loading_width="40"
          :isBusy="isBusy_table2" :hb_table_class="'hb_table_custsei_class2'">
        </TableMain>
      </template>
    </SplitContainer21>
    <el-dialog title="邮件通知" :visible.sync="emailVisible" width="40%" :top="'15vh'" :close-on-click-modal="false">
      <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 350px">
        <span v-for="(item, index) in email_dictionary" :key="index">
          <el-col :span="18">
            <el-form-item :label="item.label">
              <el-select size="small" multiple v-model="item.value" placeholder="" filterable clearable class="w-100">
                <el-option v-for="(t, k) in user_and_role" :key="k" :label="t.username" :value="t.username"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="success" @click="SaveDataEmailNotify">{{ $t('common.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import * as CustTableController from "../../controllers/base/CustTableController"
import * as commonController from "../../controllers/commonController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import SplitContainer21 from "../components/container/SplitContainer21"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "CustTableSEI",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer21,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sei_customer",
        title2: "table_customer",
      },
      fields: _.cloneDeep(CustTableController.fields.default),
      fields2: _.cloneDeep(CustTableController.fields.detail_fields),
      email_dictionary: _.cloneDeep(commonController.dictionary.email_form),
      isBusy_table1: false,
      isBusy_table2: false,
      AccountNum: "",
      SEI_Name: "",
      emailVisible: false,
      all_role_list: [],
      user_and_role: [],
      current_cust_info: null
    }
  },
  async created() {
    let _field = _.find(this.fields, { key: "SaleAreaid" })
    _field["_options"] = {
      provider: (v) => {
        return _.map(this.$store.state.biz_data.baseData.CompanyInfo, (v) => {
          return {
            value: v.DataArea,
            label:
              v.DataArea + ":" + (v.CompanyName == null ? "" : v.CompanyName),
          }
        })
      },
    }
    ///派发人(后更名为邮件通知人)
    let _field1 = _.find(this.fields, { key: "EmailNotifier" })
    _field1["multiple"] = true
    _field1["_options"] = {
      provider: (v) => {
        let users = _.map(this.$store.state.biz_data.baseData.Users, (t) => {
          return {
            value: t.username,
            label: t.username,
          }
        })
        // let dt = _.union(this.dispatcherList, users)
        return users
      },
    }
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.map(_.filter(_dt, { is_sys: false, is_valid: true }), (t) => {
        return { username: t.code }
      })
      this.user_and_role = _.map(this.$store.state.biz_data.baseData.Users, (t) => { return { username: t.username } })
      this.user_and_role = _.union(this.user_and_role, this.all_role_list)
    },
    //保存客户合同起始时间
    async SaveData(cb) {
      let data = []
      data = this.$refs.CustTable1.GetSelectedItems()
      if (data.length == 0) {
        this.msgToasts("请勾选要保存的客户信息!", "info")
        cb(false)
        return
      }
      //检查邮箱格式
      let msg = ""
      _.each(data, (t) => {
        if (t.EmailContact && t.EmailContact != "") {
          // let elt = []
          let eurl = t.EmailContact.replace(/；/g, ";")
          let emails = eurl.split(";")
          for (var i in emails) {
            if (msg == "" && !_.trim(emails[i]).match(/^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/))
              msg = "邮箱格式不正确，请检查后再保存！"
            // else
            //   elt.push(_.trim(emails[i]))
          }
          // if (msg == "" && elt.length > 0)
          //   t.EmailContact = _.join(elt, ";")
        }
      })
      if (msg != "") {
        this.msgToasts(msg, "info")
        cb(false)
        return
      }
      let _p = []
      _.each(data, (mt) => {
        let t = _.cloneDeep(mt)
        if (t.EmailNotifier && _.isArray(t.EmailNotifier) && t.EmailNotifier.length > 0) {
          t.EmailNotifier = _.join(t.EmailNotifier, ",")
        }
        else if (!_.isString(t.EmailNotifier)) {
          t.EmailNotifier = null
        }
        _p.push({
          id: t.id,
          SEI_ContractStartDate: t.SEI_ContractStartDate,
          SEI_ContractEndDate: t.SEI_ContractEndDate,
          SaleAreaid: t.SaleAreaid,
          Dispatcher: t.Dispatcher,
          EmailNotifier: t.EmailNotifier,
          EmailContact: t.EmailContact
        })
      })
      let _result = await CustTableController.methods.updateCustContractDate(_p)
      if (_result) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }
    },
    //#region 查询
    async on_query(set_data, date_range, isLoading = true) {
      if (isLoading) {
        this.isBusy_table1 = true
        set_data([])
      }
      if (!set_data || _.isNull(set_data)) {
        this.isBusy_table1 = false
        return
      } else {
        this._date_range = date_range
        this._set_data = set_data
      }
      this.AccountNum = _.trim(this.AccountNum)
      this.SEI_Name = _.trim(this.SEI_Name)
      await this.excuteQuery(set_data, date_range)
      this.isBusy_table1 = false
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      _params.is_deleted_ax = "0"
      if (this.SEI_Name != "") {
        _params.SEI_Name = this.SEI_Name
      }

      if (this.AccountNum != "") {
        _params.AccountNum = this.AccountNum
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.SEI_Name == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["FromDate"] = _fromDate
        _params["ToDate"] = _toDate
      }

      let _result = await CustTableController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          if (t.EmailNotifier && t.EmailNotifier.indexOf(",") > -1) {
            t.EmailNotifier = _.split(t.EmailNotifier, ",")
          }
          else if (_.isString(t.EmailNotifier)) {
            let ut = []
            ut.push(t.EmailNotifier)
            t.EmailNotifier = ut
          }
        })
        let dt = _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
        set_data(dt)
      }
    },
    //#endregion

    current_changed(old, current) {
      if (_.isNull(current)) {
        this.$refs.CustTable2.SetData([])
        return
      }
      this.getItemData(current)
    },
    async getItemData(current) {
      this.isBusy_table2 = true
      this.$refs.CustTable2.SetData([])
      let _result = await CustTableController.methods.getItemData({
        AccountNum: { "=": current.AccountNum },
        is_deleted_ax: { "=": 0 },
      })
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.$refs.CustTable2.SetData(_.orderBy(_result[0], ["id"], ["asc"]))
      }
      this.isBusy_table2 = false
    },
    async InvokeData() {
      // this.isBusy_table1 = true;
      // this.$refs.CustTable1.SetData([]);
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.in_async"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let _is_wait = true
      setTimeout(() => {
        if (_is_wait) {
          this.msgToasts(this.$t("notify.async_timeout"), "info")
          loading.close()
          _is_wait = false
        }
        return
      }, 1000 * 60 * 5)

      let companys = this.$store.state.biz_data.baseData.CompanyInfo
      for (var i in companys) {
        let _params = {
          company: companys[i].DataArea,
          tableName: "secp_CustTable",
          accountNum: "", //不传则查询所有
        }
        await CustTableController.methods.pickAndInvoke(_params)
      }
      let _p = {
        company: "070",
        tableName: "secp_SEI_CustTable",
        accountNum: "", //不传则查询所有
      }
      await CustTableController.methods.pickAndInvoke(_p)
      loading.close()
      if (_is_wait) {
        this.msgToasts(this.$t("notify.async_success"), "success")
        _is_wait = false
      }
      this.isBusy_table1 = true
      if (isNaN(this._set_data) && isNaN(this._date_range)) {
        this.$refs.CustTable1.SetData([])
        let _params = {
          modifiedDateTime: {
            ">=": this.$date.format(
              new Date().setMonth(new Date().getMonth() - 1),
              "yyyy-MM-dd"
            ),
            "<=": this.$date.format(
              this.$date.addDays(new Date(), 1),
              "yyyy-MM-dd"
            ),
          },
        }

        let _result = await CustTableController.methods.getData(_params)

        if (!_.isNull(_result) && _result && _result.length > 0) {
          this.$refs.CustTable1.SetData(
            _.orderBy(_result[0], ["modifiedDateTime"], ["desc"])
          )
        }
      } else {
        await this.on_query(this._set_data, this._date_range)
      }
      this.isBusy_table1 = false
    },
    async on_cell_button_click(data) {
      this.current_cust_info = data.item
      if (data.field.key == "EmailNotifierJson") {
        await this.getAllRoles()
        if (data.item.EmailNotifierJson && data.item.EmailNotifierJson != "")
          this.email_dictionary = JSON.parse(data.item.EmailNotifierJson)
        else
          this.email_dictionary = _.cloneDeep(commonController.dictionary.email_form)
        this.emailVisible = true
      }
    },
    async SaveDataEmailNotify() {
      let _p = []
      let dt = _.cloneDeep(this.email_dictionary)
      _p.push({
        id: this.current_cust_info.id,
        EmailNotifierJson: JSON.stringify(dt),
      })
      let _result = await CustTableController.methods.updateCustContractDate(_p)
      if (_result) {
        await this.on_query(this.$refs.CustTable1.SetData, this.$refs.CustTable1.date_range, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.emailVisible = false
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
  },
}
</script>
<style>
.hb_table_custsei_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 220rem;
}

.hb_table_custsei_class2 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 250rem;
}
</style>
